import { Moment } from 'moment';
import { Instituicao } from './instituicao.model';
import { Projeto } from './projeto.model';
import { ResponsavelInstituicao } from './responsavel-instituicao.model';
import { Responsavel } from './responsavel.model';

export class InstituicaoConveniadaProjeto {
  id: number;
  responsavelInstituicao: ResponsavelInstituicao;
  projeto: Projeto;
  instituicao: Instituicao;
  nomeInstituicaoMomento: string;
  descricaoEmpresa: string;
  dataInicioVinculo: Moment;
  dataFimVinculo: Moment;
}
